import React, { Component } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Row, Col, Table, Button } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import moment from "moment";
import { getReport } from "store/resultsSubmit/actions";
import logo from "../../assets/images/neqas-logo.jpeg";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  Label,
  ReferenceLine,
} from "recharts";
const sections = ["report-area"];
class ReportParticipant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportDetails: {},
      selectedAnalyte: null, // Add selectedAnalyte here
      analyteData: [],
      loading: true,
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : null, // ✅ Default to null instead of empty string
    };
  }
  componentDidMount() {
    const { id, id1 } = this.props.match.params; // roundId = id, labId = id1
    console.log("Round ID:", id, "Lab ID:", id1); // log to verify
    this.props.onGetReport(id, id1);
  }

  componentDidUpdate(prevProps) {
    const { reportData } = this.props;
    const { selectedAnalyte } = this.state;

    if (prevProps.reportData !== reportData && reportData) {
      const participantId = this.props.match.params.id1;
      console.log("Report Data:", reportData);
      console.log("Looking for participantId:", participantId);

      const participantResults = reportData.participants_results.filter(
        result => result.participant_id == participantId
      );

      // ==============================
      // ✅ PRE-ANALYTIC CHECK (UPDATED)
      // ==============================

      const hasAnyResult = participantResults.some(
        r =>
          r.result !== null &&
          r.result !== undefined &&
          r.result !== "" &&
          r.result !== "-" &&
          String(r.result).trim() !== ""
      );

      const hasSampleCondition = participantResults.some(
        r =>
          r.sample_condition &&
          r.sample_condition !== "null" &&
          r.sample_condition.trim() !== ""
      );

      const roundSampleCondition = (reportData.round_sample_condition || "")
        .toLowerCase()
        .trim();

      const sampleConditionMatched = participantResults.some(
        r =>
          roundSampleCondition !== "" &&
          (r.sample_condition || "").toLowerCase().trim() ===
            roundSampleCondition
      );

      // 🔁 CHANGED: match now wins, regardless of whether results were submitted
      const isPreAnalyticOnly = sampleConditionMatched;

      // ==============================
      // 🔥 DEBUG LOGS — remove after confirming behavior
      // ==============================
      console.log(
        "🔥 DEBUG round_sample_condition (raw):",
        reportData.round_sample_condition
      );
      console.log(
        "🔥 DEBUG roundSampleCondition (normalized):",
        roundSampleCondition
      );
      console.log(
        "🔥 DEBUG participantResults sample_condition per analyte:",
        participantResults.map(r => ({
          analyte: r.analyte_name,
          result: r.result,
          sample_condition: r.sample_condition,
          normalized_sample_condition: (r.sample_condition || "")
            .toLowerCase()
            .trim(),
        }))
      );
      console.log("🔥 DEBUG hasAnyResult:", hasAnyResult);
      console.log("🔥 DEBUG hasSampleCondition:", hasSampleCondition);
      console.log("🔥 DEBUG sampleConditionMatched:", sampleConditionMatched);
      console.log(
        "🔥 DEBUG isPreAnalyticOnly (final decision):",
        isPreAnalyticOnly
      );
      // ==============================

      // 🚨 STOP NORMAL FLOW IF TRUE
      if (isPreAnalyticOnly) {
        this.setState({
          reportDetails: {
            round: reportData.round_name || "-",
            scheme: reportData.scheme_name || "-",
            issueDate: reportData.issue_date || "-",
            closingDate: reportData.closing_date || "-",
            printDate: moment(new Date()).format("DD-MMM-YY"),
            matrix: reportData.matrix || "-",
            cycle: reportData.cycle_no || "-",
            sample: reportData.sample || "-",
          },
          analyteData: [],
          zScoreChartData: [],
          preAnalyticMessage: "Pre-Analytic challenge detected Successfully",
          loading: false,
        });

        return; // ⛔ VERY IMPORTANT
      }

      // ==============================
      // 🔽 EXISTING CODE (UNCHANGED)
      // ==============================

      const zScoreChartData = reportData.participants_results
        .filter(result => result.analyte_name === selectedAnalyte)
        .map(result => ({
          name: `Participant ${result.participant_id}`,
          ZScore: result.z_score ? parseFloat(result.z_score) : null,
        }));

      console.log("Z-Score Chart Data:", zScoreChartData);

      const analyteSummaries = reportData.analyte_result_summary || [];

      const analyteData = participantResults.map(result => {
        console.log("Analyte:", result.analyte_name, {
          result: result.result,
          evaluation: result.evaluation,
          analyte_status: result.analyte_status,
        });

        // 🔴 NEW — Participant-level abrogation: the API still sends all the
        // values, but here we show only the Abrogated message for this analyte.
        // Checked first so none of the statistics are displayed.
        if (result.abrogated) {
          return {
            analyteName: result.analyte_name ?? "",
            unit: "-",
            instrument: "-",
            count: "-",
            result: "-",
            mean: "-",
            CV: "-",
            robust_mean: "-",
            z_score_robust: "-",
            robust_deviation: "-",
            robust_sd: "-",
            upper_acceptability_limit: "-",
            lower_acceptability_limit: "-",
            zScore: "-",
            evaluation: "Abrogated",
            acceptedResults: "-",
            rejectedResults: "-",
            mu_robust_mean: "-",
            analyte_status: result.analyte_status,
            participantAbrogated: true,
          };
        }

        const hasSubmitted =
          result.result !== null &&
          result.result !== undefined &&
          result.result !== "" &&
          result.result !== "-" &&
          String(result.result).trim() !== "";

        if (!hasSubmitted) {
          return {
            analyteName: result.analyte_name ?? "",
            unit: "-",
            instrument: "-",
            count: "-",
            result: "-",
            mean: "-",
            CV: "-",
            robust_mean: "-",
            z_score_robust: "",
            robust_deviation: "-",
            robust_sd: "-",
            upper_acceptability_limit: "-",
            lower_acceptability_limit: "-",
            zScore: "-",
            evaluation: "Not Submitted",
            acceptedResults: "-",
            rejectedResults: "-",
            mu_robust_mean: "-",
            analyte_status: result.analyte_status,
          };
        }

        if (result.analyte_status === "Rejected") {
          return {
            analyteName: result.analyte_name ?? "",
            unit: "-",
            instrument: "-",
            count: "-",
            result: "-",
            mean: "-",
            CV: "-",
            robust_mean: "-",
            z_score_robust: "-",
            robust_deviation: "-",
            robust_sd: "-",
            upper_acceptability_limit: "-",
            lower_acceptability_limit: "-",
            zScore: "-",
            evaluation: "Abrogated by EQA Provider",
            acceptedResults: "-",
            rejectedResults: "-",
            mu_robust_mean: "-",
            analyte_status: result.analyte_status,
          };
        }

        return {
          analyteName: result.analyte_name ?? "",
          unit: result.unit ?? "-",
          instrument: result.instrument ?? "-",
          count: result.lab_count ?? "-",
          result: result.result,
          mean: result.mean ?? "-",
          CV: result.CV ?? "-",
          robust_mean: result.robust_mean ?? "-",
          z_score_robust: result.z_score_robust ?? "-",
          robust_deviation: result.robust_deviation ?? "-",
          robust_sd: result.robust_sd ?? "-",
          upper_acceptability_limit: result.upper_acceptability_limit ?? "-",
          lower_acceptability_limit: result.lower_acceptability_limit ?? "-",
          zScore: result.z_score ?? "-",
          evaluation: result.evaluation ?? "-",
          acceptedResults: result.accepted_results ?? 0,
          rejectedResults: result.rejected_results ?? 0,
          mu_robust_mean: result.mu_robust_mean ?? "-",
          analyte_status: result.analyte_status,
        };
      });

      let robust_mean = "-";
      let robust_sd = "-";
      if (participantResults.length > 0) {
        robust_mean = participantResults[0].robust_mean || "-";
        robust_sd = participantResults[0].robust_sd || "-";
      }

      const reportDetails = {
        round: reportData.round_name || "-",
        scheme: reportData.scheme_name || "-",
        issueDate: reportData.issue_date || "-",
        closingDate: reportData.closing_date || "-",
        printDate: moment(new Date()).format("DD-MMM-YY"),
        matrix: reportData.matrix || "-",
        cycle: reportData.cycle_no || "-",
        sample: reportData.sample || "-",
        robust_mean: reportData.robust_mean || "-",
        z_score_robust: reportData.z_score_robust || "-",
        robust_sd: robust_sd,
      };

      this.setState({
        reportDetails,
        analyteData,
        zScoreChartData,
        preAnalyticMessage: null,
        loading: false,
      });
    }
  }

  handleAnalyteSelection = analyteName => {
    this.setState({ selectedAnalyte: analyteName });
  };

  // Utility function to group Z-scores into bins
  groupZScoresNumeric = zScores => {
    const bins = [
      { x: -3, count: 0 },
      { x: -2, count: 0 },
      { x: -1, count: 0 },
      { x: 0, count: 0 },
      { x: 1, count: 0 },
      { x: 2, count: 0 },
    ];

    zScores.forEach(z => {
      if (z >= -3 && z < -2) bins[0].count++;
      else if (z >= -2 && z < -1) bins[1].count++;
      else if (z >= -1 && z < 0) bins[2].count++;
      else if (z >= 0 && z < 1) bins[3].count++;
      else if (z >= 1 && z <= 2) bins[4].count++; // include 2 here
      else if (z > 2 && z <= 3) bins[5].count++;
    });

    return bins;
  };

  handleDownloadPDF = (round, labId) => {
    const labIdValue = typeof labId === "object" ? labId.id : labId;

    // 🔹 safer way: check multiple possible keys
    let roundNameValue;
    if (typeof round === "object") {
      roundNameValue =
        round.round_name || round.rounds || round.name || round.id || "";
    } else {
      roundNameValue = round || "";
    }

    if (!roundNameValue) {
      console.error("❌ No round name provided, cannot generate URL");
      return;
    }

    fetch(
      `https://externalqcapi.com/api/registration-admin/${encodeURIComponent(
        roundNameValue
      )}/pdf/?lab_id=${labIdValue || ""}`,
      { method: "GET" }
    )
      .then(res => {
        if (!res.ok) throw new Error(`❌ Network error: ${res.status}`);
        return res.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `report_${roundNameValue}_${labIdValue || "all"}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(err => console.error("❌ PDF download error:", err));
  };

  render() {
    // const { preAnalyticMessage } = this.state;
    const { reportDetails, analyteData, loading, preAnalyticMessage } =
      this.state;
    const { selectedAnalyte } = this.state;
    const filteredZScoreData = analyteData
      .filter(analyte =>
        selectedAnalyte
          ? analyte.analyteName.toLowerCase().trim() ===
            selectedAnalyte.toLowerCase().trim()
          : true
      )
      .flatMap(analyte =>
        this.props.reportData.participants_results
          .filter(result => result.analyte_name === analyte.analyteName)
          .map(result => ({
            name: `Participant ${result.participant_id}`,
            analyteName: analyte.analyteName,
            ZScore: result.z_score ? parseFloat(result.z_score) : null,
          }))
      )
      .filter(
        data =>
          data.ZScore !== null &&
          data.ZScore !== undefined &&
          !isNaN(data.ZScore)
      );
    const zScores = filteredZScoreData.map(data => data.ZScore);
    const groupedZScoreBins = this.groupZScoresNumeric(zScores);

    if (loading) {
      return (
        <Container
          fluid
          className="d-flex justify-content-center align-items-center"
          style={{ height: "80vh" }}
        >
          {/* Reactstrap Spinner */}
          <div className="text-center">
            <div
              className="spinner-border text-primary"
              role="status"
              style={{ width: "3rem", height: "3rem" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3 fw-bold text-dark">Loading report...</p>
          </div>
        </Container>
      );
    }
    if (!analyteData.length) {
      if (preAnalyticMessage) {
        return (
          <Container
            fluid
            style={{
              paddingTop: "10%",
              paddingBottom: "10%",
              paddingLeft: "10%",
              paddingRight: "10%",
            }}
          >
            {/* Download Button */}
            <div className="d-flex justify-content-end mb-3">
              <Button
                className="w-25 no-print btn btn-outline-secondary"
                onClick={() =>
                  this.handleDownloadPDF(
                    reportDetails.round,
                    this.props.match.params.id1
                  )
                }
              >
                Download
              </Button>
            </div>

            {/* Report Header */}
            <div className="pdf-section report-header my-4">
              <div className="text-center mb-3">
                <img
                  src="https://externalqcapi.com/media/organization/nhs_logo.webp"
                  alt="Logo"
                  style={{ height: "60px", marginBottom: "10px" }}
                />
                <h4 style={{ fontWeight: "bold", color: "blue" }}>
                  NHS - National External Quality Assessment Scheme
                </h4>
              </div>
              <Row>
                <Row>
                  {/* Left Column */}
                  <Col md={6}>
                    <Row className="mb-2">
                      <Col
                        xs={6}
                        className="text-end"
                        style={{ fontWeight: "bold", color: "black" }}
                      >
                        Participant Number:
                      </Col>
                      <Col
                        xs={6}
                        className="text-left"
                        style={{ color: "blue" }}
                      >
                        {this.props.match.params.id1}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col
                        xs={6}
                        className="text-end"
                        style={{ fontWeight: "bold", color: "black" }}
                      >
                        Issue Date:
                      </Col>
                      <Col
                        xs={6}
                        className="text-left"
                        style={{ color: "blue" }}
                      >
                        {reportDetails.issueDate}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col
                        xs={6}
                        className="text-end"
                        style={{ fontWeight: "bold", color: "black" }}
                      >
                        Closing Date:
                      </Col>
                      <Col
                        xs={6}
                        className="text-left"
                        style={{ color: "blue" }}
                      >
                        {reportDetails.closingDate}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col
                        xs={6}
                        className="text-end"
                        style={{ fontWeight: "bold", color: "black" }}
                      >
                        Print Date:
                      </Col>
                      <Col
                        xs={6}
                        className="text-left"
                        style={{ color: "blue" }}
                      >
                        {reportDetails.printDate}
                      </Col>
                    </Row>
                  </Col>

                  {/* Right Column */}
                  <Col md={6}>
                    <Row className="mb-2">
                      <Col
                        xs={6}
                        className="text-end"
                        style={{ fontWeight: "bold", color: "black" }}
                      >
                        Scheme:
                      </Col>
                      <Col
                        xs={6}
                        className="text-left"
                        style={{ color: "blue" }}
                      >
                        {reportDetails.scheme}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col
                        xs={6}
                        className="text-end"
                        style={{ fontWeight: "bold", color: "black" }}
                      >
                        Cycle:
                      </Col>
                      <Col
                        xs={6}
                        className="text-left"
                        style={{ color: "blue" }}
                      >
                        {reportDetails.cycle}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col
                        xs={6}
                        className="text-end"
                        style={{ fontWeight: "bold", color: "black" }}
                      >
                        Round:
                      </Col>
                      <Col
                        xs={6}
                        className="text-left"
                        style={{ color: "blue" }}
                      >
                        {reportDetails.round}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col
                        xs={6}
                        className="text-end"
                        style={{ fontWeight: "bold", color: "black" }}
                      >
                        Sample:
                      </Col>
                      <Col
                        xs={6}
                        className="text-left"
                        style={{ color: "blue" }}
                      >
                        {reportDetails.sample}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Row>
            </div>

            {/* Pre-Analytic Message Table */}
            <Table bordered>
              <tbody>
                <tr>
                  <td
                    colSpan="10"
                    style={{ textAlign: "center", padding: "30px" }}
                  >
                    <h4 style={{ color: "red", fontWeight: "bold" }}>
                      {preAnalyticMessage}
                    </h4>
                    <p style={{ marginTop: "10px", fontWeight: "bold" }}>
                      {/* Sample Condition:{" "} */}
                      {/* {this.props.reportData?.participants_results?.[0]?.sample_condition || "-"} */}
                    </p>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Container>
        );
      }

      // This now only runs for truly empty non-pre-analytic cases
      if (!analyteData.length) {
        return (
          <Container fluid>
            <p className="text-center text-dark p-5 fs-4 fw-bold fst-italic">
              No data available for this participant.
            </p>
          </Container>
        );
      }
    }

    const defaultSorted = [
      {
        dataField: "analyte_name", // or scheme_name, name, etc.
        order: "asc", // A to Z
      },
    ];

    return (
      <Container
        id="report-area" // ✅ added
        fluid
        style={{
          paddingTop: "10%",
          paddingBottom: "10%",
          paddingLeft: "10%",
          paddingRight: "10%",
        }}
      >
        <div className="d-flex justify-content-end mb-3">
          <Button
            className="w-25 no-print btn btn-outline-secondary"
            onClick={() =>
              this.handleDownloadPDF(
                reportDetails.round,
                this.props.match.params.id1
              )
            }
          >
            Download
          </Button>
        </div>

        <style>
          {`@media print {
.no-print { display: none !important; }
  /* General print settings */
  body {
    font-size: 12px;
    line-height: 1.4;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  /* Hide unwanted elements */
  .navbar, .footer, .breadcrumb {
    display: none !important;
  }

  /* First page margins */
  @page :first {
    size: A4;
    margin: 20mm 20mm 20mm 20mm; /* top, right, bottom, left */
  }

  /* Margins for subsequent pages */
  @page {
    size: A4;
    margin: 80mm 20mm 20mm 20mm; /* bigger top margin for subsequent pages */
  }
  /* Optional: Table styling for print */
  table {
    width: 100% !important;
    border: 1px solid #d2d4d5;
    border-collapse: collapse;
  }

  th, td {
    padding: 8px;
    text-align: left;
  }

  /* Report header */
  .report-header {
    display: block !important;
  }

  .report-header h4, .report-header h6 {
    font-size: 12px;
  }
    .print-content {
    display: block;
    page-break-inside: auto;
    padding-top: 10mm; /* adds space for subsequent pages */
  }
}
 `}
        </style>

        {/* Report Header */}
        <div className="pdf-section report-header my-4">
          <div className="text-center mb-3">
            <img
              src="https://externalqcapi.com/media/organization/nhs_logo.webp"
              alt="Logo"
              style={{ height: "60px", marginBottom: "10px" }}
            />

            <h4 style={{ fontWeight: "bold", color: "blue" }}>
              NHS - National External Quality Assessment Scheme
            </h4>
          </div>
          <Row>
            <Row>
              {/* Left Column */}
              <Col md={6}>
                <Row className="mb-2">
                  <Col
                    xs={6}
                    className="text-end"
                    style={{ fontWeight: "bold", color: "black" }}
                  >
                    Participant Number:
                  </Col>
                  <Col xs={6} className="text-left" style={{ color: "blue" }}>
                    {this.props.match.params.id1}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col
                    xs={6}
                    className="text-end"
                    style={{ fontWeight: "bold", color: "black" }}
                  >
                    Issue Date:
                  </Col>
                  <Col xs={6} className="text-left" style={{ color: "blue" }}>
                    {reportDetails.issueDate}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col
                    xs={6}
                    className="text-end"
                    style={{ fontWeight: "bold", color: "black" }}
                  >
                    Closing Date:
                  </Col>
                  <Col xs={6} className="text-left" style={{ color: "blue" }}>
                    {reportDetails.closingDate}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col
                    xs={6}
                    className="text-end"
                    style={{ fontWeight: "bold", color: "black" }}
                  >
                    Print Date:
                  </Col>
                  <Col xs={6} className="text-left" style={{ color: "blue" }}>
                    {reportDetails.printDate}
                  </Col>
                </Row>
              </Col>

              {/* Right Column */}
              <Col md={6}>
                <Row className="mb-2">
                  <Col
                    xs={6}
                    className="text-end"
                    style={{ fontWeight: "bold", color: "black" }}
                  >
                    Scheme:
                  </Col>
                  <Col xs={6} className="text-left" style={{ color: "blue" }}>
                    {reportDetails.scheme}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col
                    xs={6}
                    className="text-end"
                    style={{ fontWeight: "bold", color: "black" }}
                  >
                    Cycle:
                  </Col>
                  <Col xs={6} className="text-left" style={{ color: "blue" }}>
                    {reportDetails.cycle}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col
                    xs={6}
                    className="text-end"
                    style={{ fontWeight: "bold", color: "black" }}
                  >
                    Round:
                  </Col>
                  <Col xs={6} className="text-left" style={{ color: "blue" }}>
                    {reportDetails.round}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col
                    xs={6}
                    className="text-end"
                    style={{ fontWeight: "bold", color: "black" }}
                  >
                    Sample:
                  </Col>
                  <Col xs={6} className="text-left" style={{ color: "blue" }}>
                    {reportDetails.sample}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Row>
        </div>
        <div className="pdf-section">
          {/* Analyte Table */}
          <Table
            bordered
            style={{
              border: "1px solid #d2d4d5",
              borderCollapse: "collapse",
              marginTop: "20px",
              marginBottom: "50px",
            }}
          >
            <thead>
              <tr className="text-center">
                {[
                  "Analyte",
                  "Unit",
                  "Instrument",
                  "Count",
                  "Result",
                  "Mean",
                  "Z-Score",
                  "CV",
                  "RMZ",
                  "Evaluation",
                ].map((header, idx) => (
                  <th
                    key={idx}
                    style={{
                      border: "1px solid #d2d4d5",
                      backgroundColor: "#D0F0FD", // Sky blue color
                    }}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {preAnalyticMessage ? (
                <tr>
                  <td
                    colSpan="10"
                    style={{ textAlign: "center", padding: "30px" }}
                  >
                    <h4 style={{ color: "red", fontWeight: "bold" }}>
                      {preAnalyticMessage}
                    </h4>

                    <p style={{ marginTop: "10px", fontWeight: "bold" }}>
                      Sample Condition:{" "}
                      {this.props.reportData.participants_results[0]
                        ?.sample_condition || "-"}
                    </p>
                  </td>
                </tr>
              ) : (
                analyteData.map((analyte, index) => (
                  <tr key={index}>
                    <td style={{ border: "1px solid #d2d4d5" }}>
                      {analyte.analyteName}
                    </td>
                    <td>{analyte.unit}</td>
                    <td>{analyte.instrument}</td>
                    <td>{analyte.count}</td>
                    <td>{analyte.result}</td>
                    <td>{analyte.robust_mean}</td>
                    <td>{analyte.zScore}</td>
                    <td>{analyte.CV}</td>
                    <td>{analyte.z_score_robust}</td>
                    <td
                      style={{
                        border: "1px solid #d2d4d5",
                        fontWeight: "bold",
                        color:
                          analyte.participantAbrogated ||
                          analyte.analyte_status === "Rejected"
                            ? "red"
                            : analyte.evaluation === "Acceptable"
                            ? "green"
                            : analyte.evaluation === "Warning"
                            ? "blue"
                            : analyte.evaluation === "Rejected"
                            ? "red"
                            : "black",
                      }}
                    >
                      {analyte.analyte_status === "Rejected"
                        ? "Abrogated by EQA Provider"
                        : analyte.evaluation}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>

        <div className="pdf-section">
          {analyteData
            .filter(
              analyte =>
                analyte.evaluation?.toLowerCase() !== "not submitted" &&
                !analyte.participantAbrogated // 🔴 hide individual table for participant-abrogated analytes
            )
            .map((analyte, index) => (
              <div key={index} style={{ marginBottom: "40px" }}>
                {/* Analyte Name */}
                <h3>{analyte.analyteName}</h3>

                {/* ===== FIXED FLEX CONTAINER ===== */}
                <div
                  className="analyte-box"
                  style={{
                    display: "flex",
                    gap: "24px",
                    alignItems: "stretch",
                    flexWrap: "nowrap", // ✅ FORCE ONE ROW
                    width: "100%",
                  }}
                >
                  {/* ================= TABLE SECTION ================= */}
                  <div
                    style={{
                      flex: "0 0 50%",
                      maxWidth: "50%",
                    }}
                  >
                    <Table
                      bordered
                      style={{
                        borderCollapse: "collapse",
                        border: "2px solid #d2d4d5", // <-- define your border color here (black)
                      }}
                    >
                      <tbody>
                        <tr>
                          <td style={{ background: "#f0f0f0" }}>Robust Mean</td>
                          <td>
                            <strong>{analyte.robust_mean}</strong>
                          </td>
                          <td style={{ background: "#f0f0f0" }}>Robust SD</td>
                          <td>
                            <strong>{analyte.robust_sd}</strong>
                          </td>
                        </tr>

                        <tr>
                          <td style={{ background: "#f0f0f0" }}>
                            Accepted Results
                          </td>
                          <td>
                            <strong>{analyte.acceptedResults}</strong>
                          </td>
                          <td style={{ background: "#f0f0f0" }}>
                            Rejected Results
                          </td>
                          <td>
                            <strong>{analyte.rejectedResults}</strong>
                          </td>
                        </tr>

                        <tr>
                          <td style={{ background: "#f0f0f0" }}>Test Result</td>
                          <td>
                            <strong>{analyte.result}</strong>
                          </td>
                          <td style={{ background: "#f0f0f0" }}>
                            Robust Deviation
                          </td>
                          <td>
                            <strong>{analyte.robust_deviation}</strong>
                          </td>
                        </tr>

                        <tr>
                          <td style={{ background: "#f0f0f0" }}>Z-Score</td>
                          <td>
                            <strong>{analyte.zScore}</strong>
                          </td>
                          <td style={{ background: "#f0f0f0" }}>CV (%)</td>
                          <td>
                            <strong>{analyte.CV}</strong>
                          </td>
                        </tr>

                        <tr>
                          <td style={{ background: "#f0f0f0" }}>
                            Upper Acceptability
                          </td>
                          <td>
                            <strong>{analyte.upper_acceptability_limit}</strong>
                          </td>
                          <td style={{ background: "#f0f0f0" }}>
                            Lower Acceptability
                          </td>
                          <td>
                            <strong>{analyte.lower_acceptability_limit}</strong>
                          </td>
                        </tr>

                        <tr>
                          <td style={{ background: "#f0f0f0" }}>Evaluation</td>
                          <td
                            style={{
                              width: "12.5%",
                              border: "#d2d4d5",
                              color:
                                analyte.participantAbrogated ||
                                analyte.analyte_status === "Rejected"
                                  ? "red"
                                  : analyte.evaluation === "Acceptable"
                                  ? "green"
                                  : analyte.evaluation === "Warning"
                                  ? "blue"
                                  : analyte.evaluation === "Rejected"
                                  ? "red"
                                  : "black",
                              fontWeight: "bold",
                            }}
                          >
                            {analyte.analyte_status === "Rejected"
                              ? "Abrogated"
                              : analyte.evaluation}
                          </td>

                          <td style={{ background: "#f0f0f0" }}>
                            MU (Robust Mean)
                          </td>
                          <td>
                            <strong>{analyte.mu_robust_mean}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>

                  {/* ================= GRAPH SECTION ================= */}
                  <div
                    className="chart-wrapper"
                    style={{
                      flex: "0 0 50%",
                      maxWidth: "50%",
                      height: 300,
                    }}
                  >
                    {(() => {
                      if (analyte.analyte_status === "Rejected") {
                        return null;
                      }

                      const participantId = this.props.match.params.id1;

                      const graphDataForAnalyte =
                        this.props.reportData.graph_data.find(
                          g => g.analyte_name === analyte.analyteName
                        );

                      if (
                        !graphDataForAnalyte ||
                        !graphDataForAnalyte.z_scores.length
                      ) {
                        return (
                          <p style={{ color: "red" }}>
                            No Z-Score data available for this analyte.
                          </p>
                        );
                      }

                      const groupedZScoreBins = [
                        { x: -3, min: -Infinity, max: -3, count: 0 },
                        { x: -2.5, min: -3, max: -2, count: 0 },
                        { x: -1.5, min: -2, max: -1, count: 0 },
                        { x: -0.5, min: -1, max: 0, count: 0 },
                        { x: 0.5, min: 0, max: 1, count: 0 },
                        { x: 1.5, min: 1, max: 2, count: 0 },
                        { x: 2.5, min: 2, max: 3, count: 0 },
                        { x: 3, min: 3, max: Infinity, count: 0 },
                      ];

                      graphDataForAnalyte.z_scores.forEach(z => {
                        const value = parseFloat(z.z_score);
                        groupedZScoreBins.forEach(bin => {
                          if (
                            !isNaN(value) &&
                            value >= bin.min &&
                            value < bin.max
                          ) {
                            bin.count++;
                          }
                        });
                      });

                      const participantResult =
                        this.props.reportData.participants_results.find(
                          r =>
                            r.participant_id == participantId &&
                            r.analyte_name === analyte.analyteName
                        );

                      const currentZScore =
                        participantResult?.z_score !== null &&
                        participantResult?.z_score !== undefined &&
                        !isNaN(parseFloat(participantResult.z_score))
                          ? parseFloat(participantResult.z_score)
                          : null;

                      return (
                        <ResponsiveContainer width="100%" height="100%">
                          <BarChart data={groupedZScoreBins}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis
                              dataKey="x"
                              type="number"
                              domain={[-3, 3]}
                              ticks={[-3, -2, -1, 0, 1, 2, 3]}
                            />
                            <YAxis allowDecimals={false} />
                            <Tooltip />
                            <Bar dataKey="count" fill="#3b82f6" />
                            {currentZScore !== null && (
                              <ReferenceLine
                                x={currentZScore}
                                stroke="black"
                                strokeWidth={3}
                              />
                            )}
                          </BarChart>
                        </ResponsiveContainer>
                      );
                    })()}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </Container>
    );
  }
}

ReportParticipant.propTypes = {
  match: PropTypes.object,
  reportData: PropTypes.object,
  onGetReport: PropTypes.func,
};

ReportParticipant.defaultProps = {
  reportData: {},
};

const mapStateToProps = ({ ResultSubmit }) => ({
  reportData: ResultSubmit.Report || {},
});

const mapDispatchToProps = dispatch => ({
  onGetReport: (roundId, labId) => dispatch(getReport(roundId, labId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ReportParticipant));
